(function($) {
	window.skApp = {

		props: {

			el: {
				autocomplete: '[data-google-autocomplete]',

				body: 'body',

				visualiser: '#vi',

				window: window,
			}
		},

		
		init: function() {
			/**
			 * @function init
			 */


			this.createElementMap.apply(this); // Don't remove this
			var obj=this;


			// Create the space estimator
			this.visualiser.init.call(this);

		
		},

		dlclick: function(category, action, label) {
			obj = {
				"event": "gaClick",
				"eventCategory": category,
				"eventAction": action
			};
			if (typeof label != 'undefined') {
				obj.eventLabel = label;
			}
			dataLayer.push(obj);
		},

		createElementMap: function() {
			/**
			 * @function createElementMap
			 * Creates a simplified map for referencing elements
			 */
			this.$el = {},

			_.each(this.props.el, function(value, key) {
				this.$el[key] = $(value);
			}.bind(this));
		},

		

		cubicEstiamtor: function() {
			/**
			 * @function cubicEstimator
			 * Creates the cubic metres estimator
			 */
			if (!this.$el.cubicEstimator.length) return;
			if (typeof estimator !== 'function') return;
			new estimator([10, 40, 8, 15, 30, 50, 100, 28, 85, 15, 63, 81, 145, 30, 30, 100, 130, 48, 100, 240, 60, 42, 15, 30, 20, 85, 120, 10, 10, 20, 113, 28, 113, 127, 3, 57, 91, 200, 200, 14, 6, 3, 51, 6, 68, 102, 40, 120, 40, 10, 100, 3, 48, 5, 35, 11, 60, 10, 10, 80, 14, 57, 20, 28, 28, 80, 85, 40, 60, 6, 10, 20, 8, 11, 15, 28, 8, 35, 60, 20, 20, 8, 100, 8, 75, 71, 42, 28, 20, 17, 10, 10, 20, 250, 3, 11, 40, 60, 30, 30, 14, 10, 8, 100, 14, 100, 14, 11, 48, 15, 93, 15, 60, 15, 40, 85, 30, 70, 80, 11, 120, 40, 80, 80, 28, 14, 93, 48, 30, 8, 60, 45, 250, 100, 20, 8, 11, 11, 120, 30, 100, 12, 85, 65, 200, 23, 15, 200, 98, 150, 15, 100, 25, 15, 14, 60, 42, 42, 42, 42, 14, 14]);
		},

		visualiser: {

			props: {

				timeout: null,

				desktop: {
					slick: {
						dots: true
					}
				},

				mobile: {
					slick: {
						slidesToShow: 2,
						slidesToScroll: 2,
						arrows: true,
						dots: true,
						responsive: [
							{
								breakpoint: 1024,
								settings: {
									slidesToShow: 4,
									slidesToScroll: 4,
								}
							},
							{
								breakpoint: 600,
								settings: {
									slidesToShow: 3,
									slidesToScroll: 3
								}
							},
							{
								breakpoint: 480,
								settings: {
									slidesToShow: 2,
									slidesToScroll: 2
								}
							}
						]
					}
				}
			},

			init: function() {
				/**
				 * @function visualiser
				 * Creates the visualiser
				 */

				if (!this.$el.visualiser.length) return;

				$.fn.chunk = function(size) {
					/**
					 * @function chunk
					 * Splits every {size} items into a separate stack
					 */
					var arr = [];
					for (var i = 0; i < this.length; i += size) arr.push(this.slice(i, i + size));
					return this.pushStack(arr, "chunk", size);
				}

				new vi(window.videf);
			//	{
			//		"r12": "Locker",
			//		"r13": "Quarter Garage",
			//		"r14": "Half Garage",
			//		"r15": "Three Quarter Garage",
			//		"r16": "Single Garage",
			//		"r17": "Double Garage",
			//		"r20": "Wardrobe"
			//	});

				setTimeout(function() {

					// Wrap every 8 items
					this.visualiser.groupItems.call(this, 8);

					// Store a ref to the div that will be slickified
					this.visualiser.carousel = this.$el.visualiser.find('.buttons');

					// Create the slick slider
					this.visualiser.carousel.slick(this.visualiser.props.desktop.slick);

					// Trigger the resize event
					this.$el.window.trigger('resize');

				}.bind(this), 500);
			},

			groupItems: function(numItems) {
				/**
				 * @function groupItems
				 * @param {numItems} Number
				 * Wraps ever {numItems} with a div
				 */
				if (_.isUndefined(numItems)) numItems = 8;

				var html = '<div class="buttons__group"><div class="buttons__group-wrap"></div></div>'

				return this.$el.visualiser
						.find(".buttons > .button")
						.chunk(numItems)
						.wrap(html);
			},

			handleResize: function() {
				/**
				 * @function handleResize
				 * Handles the the layout when resizing the visualiser
				 */
				if (!this.$el.visualiser.length) return;

				clearTimeout(this.visualiser.props.timeout);

				// Hide the carousel briefly
				this.visualiser.carousel.addClass('is-hidden');

				this.visualiser.props.timeout = setTimeout(function(){
					/*
						For mobile and tablet devices
						- Remove the slick slider
						- Unwrap all buttons
						- Keep all buttons at a single level
						- Rebuild the slick slider
					*/

					// If the carousel has been created
					if (!this.visualiser.carousel.hasClass('slick-initialized')) return;

					// Remove the slick slider
					this.visualiser.carousel.slick('unslick');

					// Rebuild Mobile
					if (this.$el.window.width() < 1024) {

						// Unwrap the groups
						$('.buttons__group-wrap > .button').unwrap().unwrap();

						// Rebuild the carousel
						this.visualiser.carousel.not('.slick-initialized').slick(this.visualiser.props.mobile.slick);
						this.visualiser.carousel.removeClass('is-hidden');
					}

					// Rebuild Desktop
					else {

						// Wrap every 8 items
						this.visualiser.groupItems.call(this, 8);

						// Rebuild the carousel
						this.visualiser.carousel.not('.slick-initialized').slick(this.visualiser.props.desktop.slick);
						this.visualiser.carousel.removeClass('is-hidden');
					}

				}.bind(this), 250);
			}
		},

		
		on: {

			resize: function() {
				/**
				 * @function resize
				 * Called when the window is resized
				 */
				if (this.$el.window.width() >= 1024) {
					if (this.$el.body.attr('data-menu-visible') === 'true') {
						this.$el.body.attr('data-menu-visible', false);
					}
				}

				this.$el.navOverlay.removeClass(this.props.states.visible);
				this.$el.nav.find('li.' + this.props.states.active).removeClass(this.props.states.active);

				// Handle visualiser resize
				this.visualiser.handleResize.call(this);
			},

			scroll: function(e) {
				/**
				 * @function menuItem
				 * Invoked when a menu item is clicked
				 */
				this.props.scrollPosition = $(e.target).scrollTop();

				if (this.props.scrollPosition > this.props.scrollStart) {
					return this.$el.body.attr('data-scrolling', true);
				}

				return this.$el.body.attr('data-scrolling', false);
			},

		}
	};
	window.skApp.init();
	$(window).resize(function(event) {
		window.skApp.visualiser.handleResize.call(window.skApp);
	});
})(jQuery);
